import { getLessons } from '@school_ify/schoolify-repository/src/shared/repositories/lessonRepository';
import { LessonsQueryVariables } from '@school_ify/schoolify-repository/src/shared/types';
import { StudentLessonFragment } from '@school_ify/schoolify-repository/src/student/types';

class ClassesServices {
  public async getStudentLessonsByDate(
    data: LessonsQueryVariables
  ): Promise<StudentLessonFragment[]> {
    try {
      const lessons = await getLessons(data);
      return lessons;
    } catch (err) {
      return err;
    }
  }
}

export default new ClassesServices();
